<template>
  <div class="hide-on-print">
    <!-- page Title -->
    <page-title icon="ni ni-chart-bar-32" main="Módulo de Crédito" sub="Cliente">
      <template v-slot:actions>
        <base-button
          type="neutral"
          class="ml-3 text-black"
          @click="reload"
          v-show="filterCategories == false"
        >
          <span class="btn-inner--icon mt-2">
            <i class="fa fa-angle-left"></i>
          </span>
          Voltar
        </base-button>
        <base-button
          type="neutral"
          class="ml-3 text-black"
          @click="modalImportClient = true"
        >
          <span class="btn-inner--icon mt-3">
            <i class="fa fa-plus"></i>
          </span>
          Importar cliente
        </base-button>
      </template>
    </page-title>

    <!-- Filters -->
    <card v-show="filterCategories == true">
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h5 class="h3 mb-0">Selecione o Cliente</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <base-input label="Tipo do Cliente">
            <multiselect
              v-model="filterClient.client_type"
              :loading="!client_types"
              showNoResults
              :options="client_types || []"
              placeholder="Tipo de Cliente"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
              @input="getCriClients(filterClient.client_type.id)"
            ></multiselect>
          </base-input>
        </div>
        <div class="col-3">
          <base-input label="Nome do Cliente">
            <multiselect
              v-model="filterClient.client"
              :options="criClients || []"
              :loading="!criClients"
              showNoResults
              placeholder="Nome do Cliente"
              label="razao_social"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
              @input="
                filterClient.client
                  ? (filterClient.code = filterClient.client.code)
                  : ''
              "
              @search-change="getCriClientFiltereds"
            ></multiselect>
          </base-input>
        </div>
        <div class="col-3">
          <base-input label="Por código Siagri" v-model="filterClient.code">
          </base-input>
        </div>
        <div class="col-md-3">
          <div style="margin-top: 1.8rem;">
            <base-button
              icon
              :disabled="!filterClient.code"
              @click="getClientCategories"
              type="purple"
              style="width: 70%;"
            >
              <span class="btn-inner--text text-white">Pesquisar</span>
            </base-button>
          </div>
        </div>
      </div>
    </card>
    <!-- Empty not so empty -->
    <empty-data
      v-if="filterCategories"
      suggestion="Escolha um cliente para carregar dados e tabelas."
    />

    <!-- Import Client -->
    <modal :show.sync="modalImportClient">
      <h5 class="modal-title mb-2" id="exampleModalLabel">Importar cliente</h5>
      <h5 class="card-title text-uppercase text-muted mb-4 h5">
        importar cliente do sistema de gerenciamento de vendas
      </h5>
      <div class="col-12">
        <base-input label="Nome do Cliente">
          <multiselect
            v-model="client"
            :options="clients || []"
            placeholder="Nome do Cliente"
            label="razao_social"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="code"
            @search-change="getClients"
          ></multiselect>
        </base-input>
      </div>
      <div class="col-12">
        <base-input label="Tipo do Cliente">
          <multiselect
            v-model="client.client_type"
            :options="client_types || []"
            placeholder="Tipo de Cliente"
            label="name"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            track-by="id"
            :disabled="Object.keys(client).length == 0"
          ></multiselect>
        </base-input>
      </div>
      <div class="col-12">
        <base-input label="Porte">
          <multiselect
            v-model="client.client_size"
            :options="client_sizes"
            placeholder="Porte de Cliente"
            label="name"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            :disabled="Object.keys(client).length == 0"
            track-by="id"
          ></multiselect>
        </base-input>
      </div>
      <template slot="footer">
        <base-button
          type="secondary"
          class="mr-2"
          @click="modalImportClient = false"
          >Cancelar</base-button
        >
        <base-button type="purple" @click="save">Importar</base-button>
      </template>
    </modal>

    <!-- Card Header -->
    <card v-if="filterCategories == false">
      <div class="card-header bg-blue">
        <h5 class="h3 mb-0 text-white">
          #{{ filterClient.client.code }} - {{ filterClient.client.name }}
        </h5>
      </div>
      <div class="card-body bg-blue">
        <div class="d-flex justify-content-between">
          <h5 class="h3 text-white">
            TIPO DE CLIENTE:
            <span class="text-white font-weight-normal">
              {{ filterClient.client.type.toUpperCase() }}</span
            >
          </h5>
          <h5 class="h3 text-white">
            PORTE DA EMPRESA:<span class="text-white font-weight-normal">
              {{ filterClient.client.size.toUpperCase() }}</span
            >
          </h5>
          <h5 class="h3 text-white">
            CNPJ<span class="text-white font-weight-normal">
              {{ filterClient.client.cnpj }}
            </span>
          </h5>
        </div>
      </div>
      <tabs
        tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
        tabContentClasses="card shadow"
        type="blue"
        class="bg-transparent"
        @input="onTabChange($event)"
      >
        <tab-pane id="quantity" type="info" class="bg-transparent">
          <span slot="title">
            <i class="ni ni-chart-pie-35" />
            Score e Rating
          </span>
          <score
            :keyScore="scoreKey"
            :score="filterClient.client.score"
            :client_id="filterClient.client.id"
          />
        </tab-pane>

        <tab-pane id="brand" class="bg-transparent shadow-none">
          <span slot="title">
            <i class="ni ni-badge mr-2" />
            Conceitos
          </span>
          <concepts
            :criClient="filterClient.client"
            :key="filterClient.client.id"
          />
        </tab-pane>

        <tab-pane id="thresholds">
          <span slot="title">
            <i class="ni ni-shop" />
            Culturas
          </span>
          <cultures :cultures="cultures" />
        </tab-pane>

        <tab-pane id="props">
          <span slot="title">
            <i class="ni ni-collection" />
            Propostas
          </span>
          <proposal
            :loadingProposals="loadingProposals"
            :proposals="proposals"
            :client="filterClient.client"
            :clients="clients"
          />
        </tab-pane>

        <tab-pane id="references">
          <span slot="title">
            <i class="ni ni-folder-17" />
            Referências
          </span>
          <references />
        </tab-pane>
      </tabs>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Tabs from "@/components/Tabs/Tabs";
import TabPane from "@/components/Tabs/Tab";
import EmptyData from "../../layouts/EmptyData.vue";
import Score from "../CRI/components/Score.vue";
import Concepts from "./components/Concepts.vue";
import Cultures from "./components/Cultures.vue";
import Proposal from "./components/Proposal.vue";
import References from "./components/References.vue";
import swal from "sweetalert2";

export default {
  name: "client-cri",
  components: {
    PageTitle,
    Multiselect,
    Tabs,
    TabPane,
    EmptyData,
    Score,
    Concepts,
    Cultures,
    Proposal,
    References,
  },
  data() {
    return {
      clients: [],
      client: {},
      cultures: [],
      client_types: null,
      client_type: {},
      criClient: {},
      criClients: null,
      client_sizes: [],
      filterCategories: true,
      filterClient: {},
      modalImportClient: false,
      proposals: [],
      loadingProposals: false,
      scoreKey: 1,
    };
  },
  mounted() {
    this.getClients();
    this.getCriClients();
    this.getClientTypes();
    this.getClientSizes();
  },
  methods: {
    onTabChange(tab){
      if (!(tab && tab.id)) return;

      if (tab.id == "quantity") {

        this.getClientCategories();

        this.getCriClients(null, this.filterClient.code);

        this.scoreKey++;
      }
    },
    reload() {
      window.location.reload();
    },
    async getClientTypes() {
      const response = await this.$http.secured.get(
        "/api/v1/credit_analysis/get_client_types"
      );
      this.client_types = response.data;
    },
    async getClientSizes() {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_client_sizes");
      this.client_sizes = response.data;
    },
    async getClients(q = "") {
      this.$http.secured
        .get("/api/v1/clients", { params: { q: { razao_social: q } } })
        .then((response) => (this.clients = response.data["clients"]))
        .catch((error) => console.error(error, "Something went wrong"));
    },
    getCultureIds() {
      this.$http.secured
        .get("/api/v1/clients", { params: { q: { code: this.filterClient.client.code } } })
        .then((response) => (this.cultures = response.data.clients[0].culture_ids))
        .catch((error) => console.error(error, "Something went wrong"))
    },
    getCriClientFiltereds (query) {
      var data = {
        per_page: 10,
        q: { name: query, status: true },
      }
      this.$http.secured
      .get("/api/v1/credit_analysis/get_clients", { params: data })
      .then((response) => {
        this.criClients = response.data
       })
      .catch(error => console.log(error, "Something went wrong"))
    },
    async getCriClients(client_type_id = null, code = null) {
      const data = {
        query: {},
        page: 1,
        per_page: 15,
      };

      if (client_type_id != null) data.query.client_type_id = client_type_id;

      if (code != null) data.query.code = code;

      this.$http.secured
        .get("/api/v1/credit_analysis/get_clients", { params: data })
        .then((response) => {
          this.criClients = response.data;
          if (code) {
            this.filterClient.client = response.data[0];
            this.filterClient.client.client = response.data[0].client;

            this.getClientCategories();
          }
        })
        .catch((error) => console.error(error, "Something went wrong"));
    },
    getClientCategories() {
      if (!this.filterClient.client && this.filterClient.code) {
        this.getCriClients(null, this.filterClient.code);
        return;
      }
      this.getCultureIds()
      this.filterCategories = false;
      this.getProposals(this.filterClient.client.id);
    },
    getProposals(client_id) {
      this.loadingProposals = true;
      const data = {
        query: {
          client_id: client_id,
        },
        page: 1,
        per_page: 10,
      };

      this.$http.secured
        .get("/api/v1/credit_analysis/get_proposals", { params: data })
        .then((response) => {
          this.proposals = response.data;
          this.proposals.map(
            (proposal) =>
              (proposal.validity_date = new Date(
                `${proposal.validity_date}T00:00`
              ))
          );
          this.loadingProposals = false;
        })
        .catch((error) => console.error(error, "Something went wrong"));
    },
    async save() {
      if (!this.client) return this.modalImportClient = false;
      if (!this.client.client_type) return this.modalImportClient = false;
      if (!this.client.client_size) return this.modalImportClient = false;

      const data = {
        code: this.client.code,
        client_type_id: this.client.client_type.id,
        client_size_id: this.client.client_size.id,
        name: this.client.name,
        razao_social: this.client.razao_social,
      };

      await this.$http.secured.post(`/api/v1/credit_analysis/create_clients`, data);

      this.modalImportClient = false;
      this.client = {};
      swal
        .fire({
          icon: "success",
          text: "Cliente importado com sucesso!",
          showCancelButton: true,
          confirmButtonColor: "#2dce89",
          cancelButtonColor: "#8898aa",
          confirmButtonText: "Importar Novo",
          cancelButtonText: "Fechar",
        })
        .then(async (result) => {
          await this.getCriClients();
          if (result.isConfirmed) {
            this.client = {};
            this.modalImportClient = true;
          }
        });
    },
  },
};
</script>
<style>
.tab-content {
  background-color: transparent;
}
</style>

<style scoped>
.btn-neutral {
  color: #212529;
}
</style>
